import { createSlice } from "@reduxjs/toolkit";

export const userData = createSlice({
  name: "user",
  initialState: {
    value: "",
  },
  reducers: {
    changeUser: (state, user) => {
      state.value = user;
    },
    deleteUser: (state) => {
      state.value = "";
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeUser, deleteUser } = userData.actions;

export default userData.reducer;
